<p-calendar #timeCalendar [(ngModel)]="selectedTime" timeOnly="true" hourFormat="24"
    [placeholder]="placeholder" [ngClass]="{
    'calendar-default': size === 'default',
    'calendar-compact': size === 'compact',
    'calendar-xs': size === 'xs'
  }" (onSelect)="onTimeSelect()" (onInput)="onTimeInput($event)" 
    (onClearClick)="onTimeClear()" (onBlur)="onTimeBlur($event)"
    [stepHour]="1" [stepMinute]="1" [stepSecond]="1" 
    [showSeconds]="false" [inputStyle]="{'width': '100%'}" 
    [panelStyle]="{'min-width': '280px'}" 
    appendTo="body"/>
